// extracted by mini-css-extract-plugin
module.exports = {"trigger-icon":"trigger-icon___8nm9Z","notes-badge":"notes-badge___3sarX","edited-badge":"edited-badge___1dITz"};